import { Component, signal, ChangeDetectionStrategy } from '@angular/core'
import { HeaderAdminComponent } from '../../../headers/components/header-admin/header-admin.component'
import { SidebarAdminComponent } from '../../../sidebars/components/sidebar-admin/sidebar-admin.component'

@Component({
    selector: 'app-layout-admin',
    standalone: true,
    templateUrl: './layout-admin.component.html',
    styleUrl: './layout-admin.component.scss',
    imports: [SidebarAdminComponent, HeaderAdminComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class LayoutAdminComponent {
    readonly isMobileSidebarOpen = signal(false)

    toggleMobileSidebar(): void {
        this.isMobileSidebarOpen.update((open) => !open)
    }

    closeMobileSidebar(): void {
        this.isMobileSidebarOpen.set(false)
    }
}
